
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Booking from "@/domain/booking/Booking";
import FormService from "@/services/FormService";
import InternationalizationService from "@/services/InternationalizationService";
import PhoneInput from "@/components/PhoneInput.vue";
import SearchBookingDialog from "@/components/booking/search/SearchBookingDialog.vue";
import { VuetifyForm } from "@/plugins/vuetify";
@Component({
  components: { SearchBookingDialog, PhoneInput }
})
export default class BookingDetailsForm extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: null })
  booking!: Booking | null;

  nameRules = [
    FormService.requiredStringRule,
    (v: string) =>
      (v && v.replaceAll(/\s+/g, " ").length >= 5) ||
      "Name must have at least 5 characters"
  ];

  emailRule = [FormService.emailFormatRule];

  notesRule = [FormService.maxLength255];

  languages = InternationalizationService.selectLanguages;

  contactFormValid = false;

  detailsFormValid = false;

  defaultCountryCode = "";

  name: string = "";

  email: string = "";

  phone: string = "";

  notes: string = "";

  consentLabel: string = "I agree to";

  async emitFormValid() {
    if (this.isValid && this.booking != null) {
      this.booking.phoneNumber = this.phone!;
      this.booking.email = this.email;
      this.booking.customerName = this.name.replaceAll(/\s+/g, " ");
      this.booking.notes = this.notes.replaceAll(/\s+/g, " ");
    }
    this.detailsForm.validate();

    this.$emit("input", this.isValid);
  }

  created() {
    this.defaultCountryCode = this.$store.getters.getLocalCountryCode;
  }

  get isPhoneValid() {
    return (
      this.phone &&
      this.phone !== "" &&
      FormService.phoneNumberFormatRule(this.phone) === true &&
      this.phone.length > 5
    );
  }

  get isEmailValid() {
    return (
      this.email !== "" &&
      FormService.emailFormatRule(this.email) === true &&
      this.email.length > 8
    );
  }

  get isNameValid() {
    return this.name !== "" && this.name.length >= 5;
  }

  get detailsForm() {
    return this.$refs.BookingDetailsForm as VuetifyForm;
  }

  get contactForm() {
    return this.$refs.ContactForm as VuetifyForm;
  }

  get isValid() {
    this.contactForm.validate();
    this.detailsForm.validate();
    return this.isPhoneValid && this.isEmailValid && this.isNameValid;
  }

  @Watch("booking")
  resetForm() {
    this.name = "";
    this.phone = "";
    this.email = "";
    this.notes = "";
  }
}
